import { Youtube } from "lucide-react";
import { Reveal } from "./Reveal";

const SHORT_ID = "t2GBsSnBOmY";

export const TrailerSection = () => (
  <section data-testid="trailer-section" className="px-4 sm:px-8 py-20 sm:py-28 relative overflow-hidden">
    <div className="absolute top-20 -left-24 w-72 h-72 rounded-full bg-grape/20 blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center relative">
      <Reveal className="lg:col-span-6 order-2 lg:order-1">
        <span className="text-xs font-extrabold uppercase tracking-[0.2em] text-coral">
          Sneak peek
        </span>
        <h2 className="mt-2 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight">
          Watch the fun in action
        </h2>
        <p className="mt-5 text-base sm:text-lg text-ink/70 leading-relaxed max-w-xl">
          A quick peek inside the Cute Dinosaurs Colouring Book — big, friendly pages
          ready for little hands. New clips land on our YouTube channel regularly, so
          hit subscribe and never miss a reveal.
        </p>
        <a
          href="https://www.youtube.com/@KITOE-ent"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="trailer-subscribe-button"
          className="mt-7 inline-flex items-center gap-2.5 px-7 py-4 rounded-2xl bg-[#FF0000] text-white font-display font-extrabold text-lg border-2 border-ink shadow-brutal hover:-translate-y-1 hover:shadow-brutal-lg transition-all duration-200"
        >
          <Youtube size={22} /> Subscribe on YouTube
        </a>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-6 order-1 lg:order-2 flex justify-center">
        <div className="relative">
          <div className="w-[270px] sm:w-[300px] aspect-[9/16] rounded-[2.5rem] border-2 border-ink shadow-brutal-lg overflow-hidden bg-ink rotate-2">
            <iframe
              src={`https://www.youtube.com/embed/${SHORT_ID}`}
              title="KITOE entertainment sneak peek"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
              data-testid="trailer-iframe"
            />
          </div>
          <div className="absolute -top-4 -right-4 bg-sun border-2 border-ink rounded-2xl shadow-brutal-sm px-4 py-2 font-display font-extrabold text-sm rotate-6">
            New short!
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
